module.exports = __webpack_public_path__ + "img/US_BonusDamagevsInfantry_ua.97cb19e8.webp";